import {MdError} from "react-icons/md";
import {BsBoxArrowUpRight} from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { getAuth } from "firebase/auth";

function NoPageFound(){

    const navigate=useNavigate();

    return <>
        <div className="fill-details-navbar">
            <div className='student-navbar-title' align="center">Schedule Me</div>
        </div>
        <div className="page-not-found">
            <MdError/>
            <div>Page not found</div>
            <div onClick={()=>getAuth().signOut().then(()=>{
                navigate("/");
            })}>go to Home <BsBoxArrowUpRight/></div>
        </div>
    </>
}

export default NoPageFound;